module.exports = __webpack_public_path__ + "static/media/66.c99489c7.png";